module.exports = __webpack_public_path__ + "static/flags/SB-3bf595d73b3fa8f0cf7cd91dca8098bf.gif";